var rtl_rtlignore_default = {
  "rtl": "_6vYNd",
  "ltr": "z1S9u"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
